import styled from "@emotion/styled";
export const Fonts = styled.div`
  @font-face {
    font-family: "Poppins Ligth";
    font-style: normal;
    font-weight: normal;
    src: local("Poppins Ligth"),
      url("https://bonnadona-public.s3.amazonaws.com/assets/fonts/Poppins-Light_ixvvwm.ttf")
        format("woff");
  }
  @font-face {
    font-family: "Poppins Regular";
    font-style: normal;
    font-weight: normal;
    src: local("Poppins Regular"),
      url("https://bonnadona-public.s3.amazonaws.com/assets/fonts/Poppins-Regular_lzqdk3.ttf")
        format("woff");
  }
  @font-face {
    font-family: "Poppins Medium";
    font-style: normal;
    font-weight: normal;
    src: local("Poppins Medium"),
      url("https://bonnadona-public.s3.amazonaws.com/assets/fonts/Poppins-Medium_jtdrwz.ttf")
        format("woff");
  }
  @font-face {
    font-family: "Poppins ExtraLight";
    font-style: normal;
    font-weight: normal;
    src: local("Poppins ExtraLight"),
      url("https://bonnadona-public.s3.amazonaws.com/assets/fonts/Poppins-ExtraLight_ytujuz.ttf")
        format("woff");
  }
`;
